import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPDesktopHeroGallery from '../PDPDesktopHeroGallery';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPDesktopMarxentConfigurator from '../../modular-configurator/PDPMarxentConfigurator';
const PDPDesktopPhotoPanelInner = t0 => {
  const $ = _c(12);
  const {
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2,
    slug,
    hideMarxent: t3,
    unavailableFabric: t4,
    productHeroImage: t5
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const hideMarxent = t3 === undefined ? true : t3;
  const unavailableFabric = t4 === undefined ? false : t4;
  const productHeroImage = t5 === undefined ? null : t5;
  let t6;
  if ($[0] !== hideMarxent || $[1] !== isEditOrder || $[2] !== pdpIsModularBYOProduct || $[3] !== productHeroImage || $[4] !== slug || $[5] !== unavailableFabric) {
    t6 = pdpIsModularBYOProduct ? <PDPDesktopMarxentConfigurator pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} key={slug} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /> : <PDPDesktopHeroGallery isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} productHeroImage={productHeroImage} />;
    $[0] = hideMarxent;
    $[1] = isEditOrder;
    $[2] = pdpIsModularBYOProduct;
    $[3] = productHeroImage;
    $[4] = slug;
    $[5] = unavailableFabric;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isEditOrder) {
    t7 = !isEditOrder && <PDPKeySellingPoints />;
    $[7] = isEditOrder;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className="sticky top-8">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
PDPDesktopPhotoPanelInner.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  slug: PropTypes.string,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
const PDPDesktopPhotoPanel = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPDesktopPhotoPanelInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPDesktopPhotoPanel;